<template>
  <router-view/>
</template>

<style lang="scss">
@import "assets/styles/main";
</style>
